import { render } from "./AuthAdd.vue?vue&type=template&id=62e1f560&scoped=true"
import script from "./AuthAdd.vue?vue&type=script&lang=js"
export * from "./AuthAdd.vue?vue&type=script&lang=js"

import "./AuthAdd.vue?vue&type=style&index=0&id=62e1f560&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e1f560"]])

export default __exports__